import cookie from 'react-cookie';
import get from 'lodash/get';
import merge from 'lodash/merge';
import omit from 'lodash/omit';
import * as dateTime from './datetime';

const KUSTOMER_COOKIE = 'kustomer-chat';

export const loadCookie = key => {
  const fullKustomerCookie = cookie.load(KUSTOMER_COOKIE);

  const legacyCookie = cookie.load(key);
  if (legacyCookie) {
    const newCookie = merge({}, fullKustomerCookie, { [key]: legacyCookie });
    cookie.save(KUSTOMER_COOKIE, newCookie, { path: '/' });
    cookie.remove(key);
    return legacyCookie;
  }

  const cookieExpiresAtKey = `${key}_exp`;

  const cookieExpiresAt = get(fullKustomerCookie, cookieExpiresAtKey);

  const difference = Date.now() - new Date(cookieExpiresAt);

  if (cookieExpiresAt && difference > 0) {
    const newCookie = merge({}, fullKustomerCookie, { [key]: null, [cookieExpiresAtKey]: null });
    cookie.save(KUSTOMER_COOKIE, newCookie, { path: '/' });
    return null;
  }
  return get(fullKustomerCookie, key);
};

export const saveCookie = (key, value, options) => {
  const fullKustomerCookie = cookie.load(KUSTOMER_COOKIE);
  const cookieExpiresAtKey = `${key}_exp`;

  let newCookie = merge({}, fullKustomerCookie, { [key]: value });

  if (options && options.maxAge) {
    const cookieExpiresAt = dateTime.addSeconds(new Date(), options.maxAge);

    newCookie = merge({}, newCookie, { [cookieExpiresAtKey]: cookieExpiresAt });
  } else if (get(fullKustomerCookie, cookieExpiresAtKey)) {
    newCookie = merge({}, newCookie, { [cookieExpiresAtKey]: null });
  }

  cookie.save(KUSTOMER_COOKIE, newCookie, { path: '/' });
  return newCookie;
};

export const removeCookie = key => {
  const fullKustomerCookie = cookie.load(KUSTOMER_COOKIE);
  const newCookie = omit(fullKustomerCookie, [key, `${key}_exp`]);
  cookie.save(KUSTOMER_COOKIE, newCookie, { path: '/' });
};
